<template>
  <div>
    <h2>这是<em>系统日志</em>画面！</h2>
  </div>
</template>

<script>

  export default {
    data() {
      return {

      }
    },
    methods: {
    },
    mounted() {
    }

  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/Sys/Log.vue